
import React from 'react'
export const Modal: React.FC<React.PropsWithChildren<{open:boolean; onClose:()=>void; title?:string}>> = ({open,onClose,title,children}) => {
  if(!open) return null
  return (
    <div className="fixed inset-0 bg-black/30 grid place-items-center z-50" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl p-6 min-w-[320px]" onClick={e=>e.stopPropagation()}>
        {title && <h3 className="text-lg font-semibold mb-2">{title}</h3>}
        {children}
      </div>
    </div>
  )
}
